import React, { useState } from 'react';

import Input from '../ui/Input';
import Button from '../ui/Button';
import Spinner from '../ui/Spinner';
import { parseApiError } from '../../utils/apiError';

const EMPTY = {
  fullName: '',
  phone: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'US',
};

// Reusable address form for shipping & billing. `type` ('shipping'|'billing')
// is attached to the submitted payload. Calls onCreated(newAddress) on success.
export default function AddressForm({ type, onCreate, onCreated, onCancel }) {
  const [values, setValues] = useState(EMPTY);
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});

  const setField = (key) => (e) => setValues((v) => ({ ...v, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError(null);
    setFieldErrors({});
    try {
      const created = await onCreate({ ...values, type });
      onCreated?.(created);
    } catch (err) {
      const { formError: fe, fieldErrors: fld } = parseApiError(err);
      setFormError(fe);
      setFieldErrors(fld);
      setSubmitting(false);
    }
  };

  return (
    <form className="ss-address-form" onSubmit={onSubmit} noValidate>
      {formError && <p className="ss-form__error ss-span-2" role="alert">{formError}</p>}

      <div className="ss-span-2">
        <Input label="Full name" value={values.fullName} onChange={setField('fullName')} error={fieldErrors.fullName} autoComplete="name" required />
      </div>
      <Input label="Phone" type="tel" value={values.phone} onChange={setField('phone')} error={fieldErrors.phone} autoComplete="tel" />
      <Input label="Country" value={values.country} onChange={setField('country')} error={fieldErrors.country} autoComplete="country" />
      <div className="ss-span-2">
        <Input label="Address line 1" value={values.line1} onChange={setField('line1')} error={fieldErrors.line1} autoComplete="address-line1" required />
      </div>
      <div className="ss-span-2">
        <Input label="Address line 2" value={values.line2} onChange={setField('line2')} error={fieldErrors.line2} autoComplete="address-line2" />
      </div>
      <Input label="City" value={values.city} onChange={setField('city')} error={fieldErrors.city} autoComplete="address-level2" required />
      <Input label="State" value={values.state} onChange={setField('state')} error={fieldErrors.state} autoComplete="address-level1" required />
      <Input label="Postal code" value={values.postalCode} onChange={setField('postalCode')} error={fieldErrors.postalCode} autoComplete="postal-code" required />

      <div className="ss-span-2" style={{ display: 'flex', gap: 'var(--ss-space-2)' }}>
        <Button type="submit" disabled={submitting}>
          {submitting ? <Spinner label="Saving" /> : 'Save address'}
        </Button>
        {onCancel && (
          <Button type="button" variant="ghost" onClick={onCancel}>Cancel</Button>
        )}
      </div>
    </form>
  );
}
